import {ConfigObjectType, uploadContainer, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {defineMessages, injectIntl} from 'react-intl';

import stylesLayout from './AppLayout.less';
import styles from './DiscoverLayout.less';

const I18N = defineMessages({
  PAGE_TITLE: {
    id: 'upload.pageTitle',
    defaultMessage: 'Upload Files',
    description: 'title for upload page',
  },
});

type Props = {config: ConfigObjectType; intl: any};
const UploadLayout: React.FC<Props> = (props) => {
  const {config, intl} = props;
  return (
    <div
      className={classNames({
        [stylesLayout.dlCenterColumn]: true,
        [stylesLayout.dlTopMargin]: true,
        [stylesLayout.dlCenterColumnFullRightMargin]: true,
      })}
    >
      <Helmet title={utils.TranslateUtils.translate(I18N.PAGE_TITLE, intl)} />
      <header
        className={classNames({
          [stylesLayout.dlFixedColumn]: true,
          [styles.dlFilesColumn]: true,
        })}
      >
        <uploadContainer.UploadContainer
          stateId={uploadContainer.UPLOAD_REDUCER_STATE_ID}
          config={config}
        />
      </header>
    </div>
  );
};

export default injectIntl(UploadLayout);
